module.exports = __webpack_public_path__ + "img/bg-summary-card.1d7e47fb.svg";